<template>
  <div>
    <b-form-rating v-model="value" id="ratingstar" name="ratingStar" color="#72ca4a"></b-form-rating>
    <p class="mt-2">評分: {{ value }}</p>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        value: null
      }
    }
  }
</script>